<template>
  <div class="sp-template">
    <div class="h-title">批次费用异常</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="批次号">
            <el-input type="textarea" v-model="conditions.batchIdTextArea" placeholder="多个订单号用回车分割"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search-form__buttons">
              <el-button v-if="in_configs(41701)" type="primary" size="small" @click="searchTask">搜 索</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane v-if="in_configs(41702)" label="未处理" name="false"></el-tab-pane>
          <el-tab-pane v-if="in_configs(41703)" label="已处理" name="true"></el-tab-pane>
        </el-tabs>
        <div class="button-groups" v-if="conditions.status == 'false'">
          <el-button v-if="in_configs(41704)" size="small" @click="processException">异常处理</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="batchId" label="批次号"></el-table-column>
        <el-table-column prop="message" label="异常信息"></el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">
            {{dateFormat(new Date(scope.row.createTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="conditions.status == 'false'">
          <template slot-scope="scope">
            <el-button v-show="in_configs(41705)" type="text" size="mini" @click="processException(scope.row)">计费异常处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      conditions: {
        batchIdTextArea: "",
        startDate: "",
        endDate: "",
        status: 'false'
      },
      total: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.query();
    }, 1000);
  },
  methods: {
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let batchIds = [];
      this.conditions.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          batchIds.push(d);
        }
      });
      this.$request1({
        method: 'post',
        url: '/batch/charge-exception/query',
        data: {
          batchIds: batchIds,
          startDate: this.conditions.startDate,
          endDate: this.conditions.endDate,
          processed: this.conditions.status,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    processException(row) {
      let ids = [];
      if (row.id) {
        ids.push(row.id);
      } else {
        if (this.multipleSelection.length == 0) {
          this.$message({
            message: "请选择要处理的异常",
            type: "warning"
          });
          return;
        }
        ids = this.multipleSelection.mao(a => a.id);
      }

      this.$request1({
        method: 'POST',
        url: '/batch/charge-exception/process',
        headers: { "content-type": "application/json" },
        responseType: "json",
        data: ids
      })
        .then(response => {
          if (response.data.success) {
            this.$message({
              message: "成功",
              type: "success"
            });
            setTimeout(() => {
              this.query();
            }, 500);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    dateFormat(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style>
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
  white-space: pre-wrap !important;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/batchchargeexception.vue